import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-virtual-branch-support',
  templateUrl: './virtual-branch-support.component.html',
  styleUrls: ['./virtual-branch-support.component.scss']
})
export class VirtualBranchSupportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
